import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import WorkOrder from './../../resources/WorkOrder.png';
import MaintHist from './../../resources/MaintHist.png';
import SmartEquip from './../../resources/SmartEquip.png';
import MainMenu from './../../resources/MainMenu.png';
import Insight from './../../resources/InsightMenuIcon.png';
import CycleCounts from './../../resources/CycleCountMenuIcon.png';

import { persistor } from './../../App';

import { Icon, Image, Popup } from 'semantic-ui-react'; 

const MenuButton = (props) => {
    const [open, setOpen] = useState(false);
    const routeHistory = useHistory()

    function handleLogout() {
        props.logout();
        persistor.purge();
        routeHistory.push(`/`);
    }

    const style = {
        button: {
            color: "white",
            backgroundColor: "green",
            margin: 15,
            borderRadius: "50%",
            width: 50,
            height: 50,
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            cursor: "pointer"
        },
        popup: {
            color: "white",
            backgroundColor: "#424242",
            display: "flex",
            flexDirection: "column"
        },
        user: {
            display: "flex",
            flexDirection: "row"
        },
        menu: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap"
        },
        menuButton: {
            height: 66,
            width: 66,
            border: "1px solid black",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer"
        },
        image: {
            height: 66,
            width: 66,
            cursor: "pointer"
        }
    }

    let nameArray = (!!props.user_details) ? props.user_details[props.company].name.split(" ") : "";
    let initials = nameArray[1].charAt(0) + nameArray[0].charAt(0);

    return (
        <Popup
            style={{backgroundColor:"#424242", border: "1px solid #424242"}}
            open={open}
            wide="very"
            content={
                <div style={style.popup}>
                    <div style={style.user}>
                        <div style={{width: "66.66%"}}>{props.user_details[props.company].name}</div>
                        <div style={{width: "33.33%", textAlign: "right"}}><Icon name="sign out" style={{cursor: "pointer", color:"white"}} onClick={handleLogout} /></div>
                    </div>
                    <div style={style.menu}>
                        <Image src={MainMenu} style={style.image} onClick={() => routeHistory.push("/dashboard")} />
                        <Image src={WorkOrder} style={style.image} onClick={() => routeHistory.push("/wo/dashboard")} />
                        <Image src={MaintHist} style={style.image} onClick={() => routeHistory.push("/mainthist")} />
                        <Image src={SmartEquip} style={style.image} onClick={() => routeHistory.push("/smartequip/dash")} />
                        <Image src={Insight} style={style.image} onClick={() => routeHistory.push("/insight")} />
                        <Image src={CycleCounts} style={style.image} onClick={() => window.location = "https://secured-demo.issiconsulting.com"} />
                    </div>
                </div>
            }
            trigger={
                <div style={style.button} onClick={() => setOpen(!open)}>{initials}</div>
            }
            position="bottom right"
        />
    )
}

MenuButton.defaultProps = {
    user_details: []
}

export default MenuButton;